import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-widget-revenuetotal',
  templateUrl: './revenuetotal.component.html',
  styleUrls: ['./revenuetotal.component.scss']
})
export class RevenuetotalComponent implements OnInit {

  total:any;
  transact:any;
  pending:any;
  transacttoday:any;
  policytoday:any;

  loaderror:any='';
  loading:boolean = false;
  userdata :any //get user id

  constructor(private service:DashboardService) {
    this.userdata=this.service.currentUser();
  }

  ngOnInit() {
 
    this.loading = true
    let payload: any={}

    if(this.userdata.role==='client'){
      payload={
        role:'client',
        client_code:this.userdata.code
      }
    }else if(this.userdata.role==='agent' || this.userdata.role==='broker-admin'){
      payload={
        role:'agent',
        agent_code:this.userdata.code
      }
    }else if(this.userdata.role==='broker-user'){
      payload={
        role:'broker-user',
        broker_user_code:this.userdata.code
      }
      
    }else{}


      this.service.getAnaytics(payload).subscribe(data=>{
        this.loading = false
      
        if(data.hasOwnProperty('total_transactions'))
        this.total = parseFloat(data['total_transactions'][0]['totalAmount'].replace(",",""));
      
      }, error => {
        this.loading = false
        this.loaderror = 'failed to fetch data. Reload'
        swal.fire({
          title: 'Oops...',
          text: error.name,
          footer: ''
        });
      });






  }

}
